/**
 * 客资所有状态
 * */
import {fGetColumns} from '../util'


const state = {

  // 所有表头
  allTable: {},

  //客资导航数量
  kzMenuNumber: [],

  //当前客资表头
  kzTable: [],

  //客资数量
  kzTableData: [],

  //客资loading
  serciveLoad: false,

  //选中的客资
  kzCustomIds: [],

  //客资页数
  pageConfig: {
    totalcount: 1,
    pagesize: 50,
    currentpage: 1,
    totalpage: 1,
  },
}

const getters = {
  allTable: state => {
    return state.allTable
  },
  kzMenuNumber: state => {
    return state.kzMenuNumber
  },
  kzTable: state => {
    return state.kzTable
  },
  kzTableData: state => {
    return state.kzTableData
  },
  serciveLoad: state => {
    return state.serciveLoad
  },
  kzCustomIds: state => {
    return state.kzCustomIds
  },
  pageConfig: state => {
    return state.pageConfig
  },
}

const mutations = {
  setKzMenu(state, data) {
    state.kzMenuNumber = data
  },
  setKzTable(state, data) {
    let selectMenu = fGetColumns(data)
    data.map(item => {
      state.allTable[item.action] = selectMenu[item.action]
    })
  },
  setKzSelectTable(state, data) {
    state.kzTable = state.allTable[data]
  },
  setKzTableData(state, data) {
    if (!data) {
      state.kzTableData = []
    } else {
      state.kzTableData = data

    }
  },
  setSerciveLoad(state, data) {
    state.serciveLoad = data
  },
  setKzCustomIds(state, data) {
    if (data) {
      state.kzCustomIds = data
    } else {
      state.kzCustomIds = []
    }
  },
  setPageConfig: (state, data) => {
    if (!data) {
      state.pageConfig.totalcount = 1
      state.pageConfig.totalpage = 0
    }
    state.pageConfig.totalcount = data.totalcount
    state.pageConfig.totalpage = data.totalpage
  },
  setClearTable: (state, data) => {
    state.allTable = {}
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/model/home.js